import { makeStyles } from '@material-ui/core'
import { css } from 'styled-components'

export const useStyles = makeStyles((theme) => ({
	title: {
		...theme.typography.h3,
		color: theme.palette.primary.main,
	},
	actions: {
		padding: '16px 24px',
	},
}))

export const labelStyle = css`
	font-weight: 600;
	display: flex;
	align-items: center;
	letter-spacing: 0.1px;
	color: ${({ theme }) => theme.colors.primary.main} !important;

	.MuiFormLabel-root.Mui-disabled {
		color: ${({ theme }) => theme.overrides.MuiButton.containedPrimary.color} !important;
	}

	.MuiInputBase-root.Mui-disabled {
		color: ${({ theme }) => theme.palette.content.veryDark};
	}
`
